const constants = {
    MENU_TOP_HIDE: 'MENU_TOP_HIDE',
    MENU_TOP_SHOW: 'MENU_TOP_SHOW',
    MENU_LEFT_HIDE: 'MENU_LEFT_HIDE',
    MENU_LEFT_SHOW: 'MENU_LEFT_SHOW',
    MENU_RIGHT_HIDE: 'MENU_RIGHT_HIDE',
    MENU_RIGHT_SHOW: 'MENU_RIGHT_SHOW',
    MENU_TAILORMADE_HIDE: 'MENU_TAILORMADE_HIDE',
    MENU_TAILORMADE_SHOW: 'MENU_TAILORMADE_SHOW',
    MENU_BRIDES_HIDE: 'MENU_BRIDES_HIDE',
    MENU_BRIDES_SHOW: 'MENU_BRIDES_SHOW',
    MENU_BS_HIDE: 'MENU_BS_HIDE',
    MENU_BS_SHOW: 'MENU_BS_SHOW'
};

export default constants;



// WEBPACK FOOTER //
// ./src/constants/MenuConstants.js